/**
 * AsyncAPI broker security scheme type names, grouped by the credential shape they share.
 *
 * These sets are the single source of truth for the runtime type guards used both when extracting
 * stored secrets and when rendering the credential inputs, so the two stay in sync.
 */
/** SASL-style broker schemes: all of them authenticate with a username + password pair. */
const SASL_SCHEME_TYPES = ['userPassword', 'plain', 'scramSha256', 'scramSha512'];
export const isSaslSchemeType = (type) => Boolean(type) && SASL_SCHEME_TYPES.includes(type);
/** Encryption broker schemes: a single key value. */
const ENCRYPTION_SCHEME_TYPES = ['symmetricEncryption', 'asymmetricEncryption'];
export const isEncryptionSchemeType = (type) => Boolean(type) && ENCRYPTION_SCHEME_TYPES.includes(type);
